

import { data } from "./requestsPage.data";
import { dataTerminal } from "./requestsPageTerminal.data";

import Header from "../../../layout/Header/Header";
import MultiRoute from "../../../common/MultiRoute/MultiRoute";
import Footer from "../../../layout/Footer/Footer";

import { mode } from "../../../../app/mode";
import {isTerminal} from "../../../../constants";
import {routerTerminal} from "../hrServicePageTerminal.data";

import { getAllRequests } from "../../../../redux/actions/Requests/thunk/getAllRequests.thunk.action";




import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";

const router = isTerminal ? routerTerminal : data;


function Requests(props) {
    const dispatch = useDispatch();
    const categories = useSelector((state) => state.requests.categories);


    useEffect(() => {
        dispatch(getAllRequests());
    }, []);


    return (
        <>
            <Header />
            {/*{isTerminal && <ScrollButton />}*/}
            <MultiRoute
                data={
                // mode === "UNSTABLE" ?
                    (categories && categories.length  ? categories : [])
                    // : router
            }
                styleParent={"hr-services"}
                breadCrumbs={true}
                subHeader={"Заявки"}
            />

            <Footer /></>
    );
}

export default Requests;
